import React from 'react'
import { Stack, Tooltip, Chip, ChipProps } from '@mui/material'
import { Theme, useTheme } from '@mui/material/styles'
import { SxProps } from '@mui/system'
import { Info as InfoIcon, ReceiptLong as ReceiptLongIcon } from '@mui/icons-material'

interface InvoicedStatusChipProps extends Omit<ChipProps, 'label'> {
  showIcon?: boolean
  showTooltip?: boolean
  tooltipText?: string
  chipSx?: SxProps<Theme>
}

const InvoicedStatusChip: React.FC<InvoicedStatusChipProps> = ({
  showIcon = true,
  showTooltip = true,
  tooltipText,
  chipSx = {},
  ...props
}) => {
  const theme = useTheme()

  const chipComponent = (
    <Chip
      variant="outlined"
      icon={
        showIcon ? (
          <ReceiptLongIcon
            sx={{
              '&.MuiChip-icon': {
                color: theme.palette.primary.main,
              },
            }}
          />
        ) : undefined
      }
      label="Invoiced"
      sx={{
        '.MuiChip-icon': {
          color: theme.palette.primary.main,
        },
        ...chipSx,
      }}
      {...props}
    />
  )

  if (!showTooltip || !tooltipText) {
    return chipComponent
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {chipComponent}
      <Tooltip title={tooltipText} placement="right" arrow>
        <InfoIcon fontSize="small" />
      </Tooltip>
    </Stack>
  )
}

export default InvoicedStatusChip
